/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

export enum ComplianceNotificationTypeEnum {
  NOT_SET = 'NotSet',
  NOTIF_NONCOMPLIANCES = 'NotifNoncompliances',
  NOTIF_COMPLIANCE_REASONS = 'NotifComplianceReasons',
  NOTIF_CORRECTED_PREMIUM = 'NotifCorrectedPremium',
  INVALID = 'Invalid',
  MISSING_ENUM = 'MissingEnum',
}
